// extracted by mini-css-extract-plugin
export var childPages = "Article-module--childPages--AC+GJ";
export var footer = "Article-module--footer--5e1OH";
export var siblingPages = "Article-module--siblingPages--djaRD";